import axios from 'axios';

export const  GetSchedulerList=(where:string)=>{
   return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`capacity?where=${where}`);
}
